module.exports = __webpack_public_path__ + "fonts/NotoSans-Bold.5f7ac34.ttf";